export default function Browser ()
{
  const init = () =>
  {
    const uAgent = navigator.userAgent;

    this.isIE = (document.all && window.clientInformation) ? parseInt(window.clientInformation.userAgent.substr(window.clientInformation.userAgent.indexOf('MSIE ') + 5, 3)) : 0;
    this.isEdge = (uAgent.indexOf('Edge/') !== -1);
    this.isSafari = uAgent.indexOf('Safari') !== -1;
    this.isOpera = uAgent.indexOf('Opera') !== -1;
    this.isGecko = uAgent.indexOf('Gecko') !== -1 && !this.isSafari && !this.isOpera;
    this.isWebKit = (uAgent.indexOf('WebKit') !== -1 && window.devicePixelRatio);
    this.matchWebKitVer = (this.isWebKit) ? uAgent.match(/[\s\S]*?(?:Version|Chrome)\/(\d+)\.?(\d*)\.?(\d*)[\s\S]*/i) : null;
    this.webKitVer = (this.matchWebKitVer && this.matchWebKitVer[1]) ? this.matchWebKitVer[1] : 5;
    this.webKitVer1 = (this.matchWebKitVer && this.matchWebKitVer[2]) ? this.matchWebKitVer[2] : 0;
    this.webKitVer2 = (this.matchWebKitVer && this.matchWebKitVer[3]) ? this.matchWebKitVer[3] : 0;
    this.isWebKit = (this.isWebKit && ((uAgent.indexOf('Version/') !== -1 && (this.webKitVer === 4 && ((this.webKitVer1 === 0 && this.webKitVer2 >= 4) || this.webKitVer1 > 0)) || this.webKitVer > 4) || (uAgent.indexOf('Chrome/') !== -1 && this.webKitVer >= 3)));
    this.isWebKitSafari = (this.isWebKit && uAgent.indexOf('Version/') !== -1);
    this.isWebKitChrome = (this.isWebKit && (uAgent.indexOf('Chrome/') !== -1 || uAgent.indexOf('CriOS/') !== -1));
    this.isOnBeforeUnloadEnabled = (!BEditor.device.isIOS && (!this.isWebKit || (this.isWebKit && ((uAgent.indexOf('Version/') !== -1 && this.webKitVer >= 5) || this.webKitVer >= 7))));
    this.isMac = uAgent.indexOf('Mac') !== -1;
    this.isTouchEventsSupported = !!(('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch) || (navigator.msPointerEnabled && navigator.msMaxTouchPoints));

    if (/Firefox\/(\S+)/.test(uAgent))
    {
      this.Version = RegExp['$1'];
      this.Firefox = parseFloat(this.Version);
    }
  };

  init();
}